// extracted by mini-css-extract-plugin
export var backdropBlur = "_ln-0";
export var contentCard = "_ln-5";
export var frame = "_ln-2";
export var image = "_ln-4";
export var imagePane = "_ln-3";
export var modal = "_ln-1";